(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-module"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-modules')) {
    customElements.define(
      'product-modules',
      class ProductModules extends HTMLElement {
        connectedCallback() {
          this.toggleBtn = this.querySelector('.product-modules__toggle');
          this.panel = this.querySelector('.product-modules__panel');
          this.closeBtn = this.querySelector('.product-modules__close');
          if (!this.toggleBtn || !this.panel) return;

          this.onDocClick = (e) => {
            if (!this.contains(e.target)) this.close();
          };
          this.onKey = (e) => {
            if (e.key === 'Escape') {
              this.close();
              this.toggleBtn.focus();
            }
          };

          // Stop clicks bubbling to the card, so it doesn't open the parent product
          this.toggleBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.panel.hidden ? this.open() : this.close();
          });
          this.closeBtn?.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.close();
          });
          this.panel.addEventListener('click', (e) => e.stopPropagation());
        }

        open() {
          document.querySelectorAll('product-modules').forEach((el) => {
            if (el !== this && typeof el.close === 'function') el.close();
          });
          this.panel.hidden = false;
          this.toggleBtn.setAttribute('aria-expanded', 'true');
          document.addEventListener('click', this.onDocClick);
          document.addEventListener('keydown', this.onKey);
        }

        close() {
          if (!this.panel) return;
          this.panel.hidden = true;
          this.toggleBtn.setAttribute('aria-expanded', 'false');
          document.removeEventListener('click', this.onDocClick);
          document.removeEventListener('keydown', this.onKey);
        }

        disconnectedCallback() {
          this.close();
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
